export default "__VITE_ASSET__DLPKw0Fa__"